
export class ApiKey {
  id: string;
  hash: string | undefined;
  comment: string| undefined;
  lastUsedDateTime: string| undefined;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.hash = payload.hash;
      this.comment = payload.comment;
      this.lastUsedDateTime = payload.lastUsedDateTime;
    }
  }
  /**
   * creates roles from a result
   * @param result Array of any
   * @returns Array of ApiKey
   */
   static createApiKeys(result: Array<any>): ApiKey[] {
    const keys = new Array<ApiKey>();
    if (result) {
      result.map((key) => {
        keys.push(new ApiKey(key));
      });
    }
    return keys;
  }
}

export class ApiKeyCreateResult {

  apiKeyData: string | undefined;
  apiKeyId: string | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.apiKeyData = payload.apiKeyData;
      this.apiKeyId = payload.apiKeyId;
    }
  }
}

export class ApiKeyInput {
  id: string;
  comment: string| undefined;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.comment = payload.comment;
    }
  }
}

